<template>
  <div data-testid="balances-loader" class="balances-loader">
    <SkeletonLoader class="available-loader" show-animation>
      <div class="available-loader__title" />
      <div class="available-loader__total" />
    </SkeletonLoader>
    <SkeletonLoader class="operation-loader" show-animation>
      <div class="operation-loader__title" />
      <div class="operation-loader__total" />
    </SkeletonLoader>
    <SkeletonLoader class="operation-loader" show-animation>
      <div class="operation-loader__title" />
      <div class="operation-loader__total" />
    </SkeletonLoader>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { SkeletonLoader } from '@warrenbrasil/nebraska-web';

@Component({
  components: {
    SkeletonLoader
  }
})
export default class BalancesLoader extends Vue {}
</script>

<style lang="less" scoped>
.balances-loader {
  display: flex;
  align-items: center;

  .available-loader {
    margin-right: @size-spacing-x900;
    &__title {
      width: 173px;
      height: 24px;
      border-radius: @size-radius-x100;
      margin-bottom: @size-spacing-x150;
    }
    &__total {
      width: 233px;
      height: 49px;
      border-radius: @size-radius-x100;
      margin-bottom: @size-spacing-x150;
    }
    &__earnings {
      width: 204px;
      height: 24px;
      border-radius: @size-radius-x100;
    }
  }
  .operation-loader {
    margin-right: @size-spacing-x900;
    &__title {
      width: 107px;
      height: 20px;
      border-radius: @size-radius-x100;
      margin-bottom: @size-spacing-x150;
    }
    &__total {
      width: 107px;
      height: 30px;
      border-radius: @size-radius-x100;
    }
  }
}
</style>
